import { useEffect, useState } from 'react';

export const useOpenIntercom = () => {
  const [isIntercomOpen, setIsIntercomOpen] = useState(false);
  useEffect(() => {
    if (!window.Intercom) {
      return;
    }

    const onShow = () => setIsIntercomOpen(true);
    const onHide = () => setIsIntercomOpen(false);

    window.Intercom('onShow', onShow);
    window.Intercom('onHide', onHide);

    return () => {
      window.Intercom?.('offShow', onShow);
      window.Intercom?.('offHide', onHide);
    };
  }, []);

  const handleSupportClick = () => {
    if (typeof window === 'undefined' || !window.Intercom) {
      return;
    }

    if (isIntercomOpen) {
      window.Intercom('hide');
    } else {
      window.Intercom('show');
    }
  };

  return { isIntercomOpen, handleSupportClick };
};
